import { Injectable } from "@angular/core";
import { HttpWrapperService } from "../http-wrapper.service";
import { map, Observable } from "rxjs";
import { HttpHeaders } from "@angular/common/http";
import { IHttpRequestOptions } from "../../interfaces/http-request-option.interface";
import { IContributor } from "../../interfaces/contributor.interface";

@Injectable({
  providedIn: 'root'
})

export class ContributorService {
   constructor(private httpWrapperService: HttpWrapperService) {}

  validateContributor(
    communityId: number,
    plaqueId: number,
    email: string,
  ): Observable<string> {
    const url = `ValidateUserPlaque`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');

    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: {
          communityId: communityId,
          plaqueId: plaqueId,
          emailAddress: email
        }
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: string) => response)
    );
  }

  addContributorsWithPlaques(communityId:number, plaqueId: number, contributors: IContributor[], isSaveStory = 'false'): Observable<boolean> {
    const url = `LinkedUserPlaque/${communityId}/${plaqueId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const params: { [key: string]: string } = {};
    params['isSaveStory'] = isSaveStory;
    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
        body: contributors,
        params: params
      };
    return this.httpWrapperService.postFromApiGateWay(options).pipe(
        map((response: boolean) => response)
    );
  }
  getContributorsLinkedToWithPlaque(plaqueId: number): Observable<IContributor[]> {
    const url = `LinkedUserPlaque/list/${plaqueId}`;
    const headers = new HttpHeaders().set('Content-Type', 'application/json');
    const options: IHttpRequestOptions = {
        url: url,
        headers: headers,
      };
    return this.httpWrapperService.getFromApiGateWay(options).pipe(
        map((response: IContributor[]) => response)
    );
  }

}